import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { extractIdFromUrl, getProjectTypeFromUrl } from '../../utils/url.util';
import { IViewerStore } from './viewer.store';
import { ProjectAction, ViewerStore } from './viewer.types';

export interface ProjectState {
  project: ViewerStore['project'];
  company: ViewerStore['company'] | null;
  collaborators: ViewerStore['collaborators'];
  isProjectEditable: boolean;
  isProjectUsable: boolean;
  isProjectSharable: boolean;
  isProjectActionRequireApproval: Record<ProjectAction, boolean>;
}

export interface ProjectActions {
  setProject: (project: Partial<ViewerStore['project']>) => void;
  setCompany: (company: Partial<ViewerStore['company']>) => void;
  setCollaborators: (collaborators: ViewerStore['collaborators']) => void;
  setIsProjectEditable: (isProjectEditable: boolean) => void;
  setIsProjectUsable: (isProjectUsable: boolean) => void;
  setIsProjectSharable: (isProjectSharable: boolean) => void;
  setIsProjectActionRequireApproval: (status: Record<ProjectAction, boolean>) => void;
}

export type ProjectSlice = ProjectState & ProjectActions;

export const createProjectSlice: StateCreator<IViewerStore, [], [], ProjectSlice> = (set) => ({
  project: {
    id: ((url: URL) => extractIdFromUrl(url))(
      new URL(window.location.pathname, window.location.origin)
    ),
    type: ((url: URL) => getProjectTypeFromUrl(url))(
      new URL(window.location.pathname, window.location.origin)
    ),
    isOwner: null,
  },
  company: {
    is_workspace: false,
    id: 1,
    name: 'fluer',
    domain: 'fluer',
    features: {},
    parent_domain: null,
  },
  collaborators: [],
  isProjectEditable: false,
  isProjectUsable: false,
  isProjectSharable: false,
  isProjectActionRequireApproval: {
    download: false,
    share: false,
  },
  setCompany: (company) =>
    set(
      produce((draft) => {
        draft.company = {
          ...draft.company,
          ...company,
        };
      })
    ),
  setProject(project) {
    set(
      produce((draft) => {
        draft.project = {
          ...draft.project,
          ...project,
        };
      })
    );
  },
  setCollaborators: (collaborators) =>
    set(
      produce((draft) => {
        draft.collaborators = collaborators;
      })
    ),
  setIsProjectEditable: (isProjectEditable) =>
    set(
      produce((draft) => {
        draft.isProjectEditable = isProjectEditable;
      })
    ),
  setIsProjectUsable: (isProjectUsable) =>
    set(
      produce((draft) => {
        draft.isProjectUsable = isProjectUsable;
      })
    ),
  setIsProjectSharable: (isProjectSharable) =>
    set(
      produce((draft) => {
        draft.isProjectSharable = isProjectSharable;
      })
    ),
  setIsProjectActionRequireApproval: (status) =>
    set(
      produce((draft) => {
        draft.isProjectActionRequireApproval = status;
      })
    ),
});
